module.exports = __webpack_public_path__ + "img/clian2.de9a6f5a.png";